// Package Imports
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Module Imports
import {
  lobbyDetailQueryOptions,
  lobbyListQueryOptions,
} from '@/modules/lobby/lobby.hooks'

export const lobbyRoute = createRoute({
  path: '/lobbies',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const lobbyListRoute = createRoute({
  getParentRoute: () => lobbyRoute,
  path: '/',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'lobbies.inspect',
      'Aktif lobiler listesine erişim izniniz yok.'
    )
  },
  head: () => ({
    meta: [{ title: 'Aktif Lobiler' }],
  }),
  loader: async () => {
    await queryClient.ensureQueryData(lobbyListQueryOptions())
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/lobby/pages/list-lobby.page')
  ),
})

export const lobbyDetailRoute = createRoute({
  getParentRoute: () => lobbyRoute,
  path: '/$id',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'lobbies.inspect',
      'Lobi detayına erişim izniniz yok.'
    )
  },
  head: () => ({
    meta: [{ title: 'Lobi Detayı' }],
  }),
  loader: async ({ params: { id } }) => {
    await queryClient.ensureQueryData(lobbyDetailQueryOptions(id))
  },
  component: lazyRouteComponent(
    () => import('@/modules/lobby/pages/lobby-detail.page')
  ),
})
